// Make sure path is correct
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { CoreHelperUtil } from '@reown/appkit';
import * as Sentry from '@sentry/capacitor';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import './patches/reown-monkey-patch';

if (environment.production) {
    enableProdMode();
}

Sentry.init(
    {
        dsn: `${environment.sentryDns}`,
        release: `bondex-app@${environment.version}-${environment.build}`,
        dist: environment.build,
        integrations: integrations => [...integrations],
        tracesSampleRate: 0.2,
        environment: environment.name,
    },
    Sentry.init
);

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));
defineCustomElements(window);
